import { Directive, OnChanges, SimpleChanges, OnDestroy, Input, TemplateRef } from '@angular/core';
import { ProjectionService } from './projection.service';

@Directive({
  selector: 'ng-template[projector]',
})
export class ProjectionDirective implements OnChanges, OnDestroy {
  @Input() projector: string;

  constructor(private projectionService: ProjectionService, private template: TemplateRef<unknown>) {}

  ngOnChanges(changes: SimpleChanges): void {
    const projectorName = changes.projector;
    if (!projectorName) {
      return;
    }

    if (projectorName.previousValue) {
      this.projectionService.clear(projectorName.previousValue);
    }

    if (projectorName.currentValue) {
      this.projectionService.activate(projectorName.currentValue, this.template);
    }
  }

  ngOnDestroy(): void {
    if (this.projector) {
      this.projectionService.clear(this.projector);
    }
  }
}
